import React, { Fragment } from "react"
import Taps from "./Taps"
import Links from "./Links"
import HeaderMessege from "./HeaderMessage"
import { pushRotate as Menu } from "react-burger-menu"
import windowDimensions from "../util/windowDimensions"
import { TapTag } from "./globalStyles"
import "./header.css"
const Header = ({ children }) => {
  const { height, width } = windowDimensions()
  var styles = {
    // burger button style
    bmBurgerButton: {
      position: "absolute",
      width: "36px",
      height: "30px",
      right: "3px",
      top: "1px",
    },
    bmBurgerBars: {
      background: "white",
    },
    bmBurgerBarsHover: {
      background: "none",
    },
    bmCrossButton: {
      height: "14px",
      width: "14px",
    },
    bmCross: {
      background: "white",
    },
    // menu style
    bmMenuWrap: {
      position: "fixed",
      top: "0",
      bottom: "0",
      height: "100%",
      width: "100%",
      margin: "0px",
      padding: "0px",
    },
    bmMenu: {
      background: "#060c21",
      padding: "0px",
      margin: "0px",
      fontSize: "1.15em",
    },
    bmMorphShape: {
      fill: "white",
    },
    bmItemList: {
      color: "white",
      paddingTop: "4em",
    },
    bmItem: {
      display: "inline-block",
      width: "70%",
    },
    bmOverlay: {
      background: "#060c21",
    },
  }
  return (
    <Fragment>
      <div className="full-view">
        <Taps />
      </div>
      <div className="mobile-view">
        <Menu styles={styles} right>
          <TapTag to="/">Home</TapTag>
          <TapTag to="/resume">Resume</TapTag>
          <TapTag to="/about">About</TapTag>
          <TapTag to="/contact">Contact</TapTag>
        </Menu>
      </div>

      <div style={width < 800 ? { marginTop: "40px" } : {}}>
        <HeaderMessege />
        <Links />
        <h3>Junior Software Developer in California </h3>
      </div>
    </Fragment>
  )
}
export default Header
